import { styled, Typography } from '@mui/material';
import { Error } from '@mui/icons-material';
import { theme } from 'assets/themes/zizzi';
import Modal from 'components/Modal';

export const Title = styled(Typography)`
  margin: 0.5rem 0 1.25rem;
  text-align: center;
`;

export const Text = styled(Typography)`
  margin-bottom: 1rem;
  text-align: center;
`;

export const StyledModal = styled(Modal)`
  ${theme.breakpoints.up('sm')} {
    .MuiCardContent-root {
      min-width: 0;
    }

    .MuiPaper-root {
      max-width: 500px;
    }
  }
`;

export const Message = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
  text-align: center;
`;

export const StyledErrorIcon = styled(Error)`
  color: ${theme.palette.error.main};
  font-size: 56px;
  margin-bottom: 2rem;
`;
